import { render, staticRenderFns } from "./VesselNotes.vue?vue&type=template&id=4894732c&scoped=true&"
import script from "./VesselNotes.vue?vue&type=script&lang=ts&"
export * from "./VesselNotes.vue?vue&type=script&lang=ts&"
import style0 from "./VesselNotes.vue?vue&type=style&index=0&id=4894732c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4894732c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAlert,VBtn,VProgressCircular,VTextarea})
